import React from "react";
import { StyleSheet, View, ScrollView } from "react-native";
import { colors } from "src/assets";
import { ReviewCard } from "src/components";
import { NotFound } from "./components";
import { useReviewsByOfferToUser } from "./hooks";
import { useRoute, RouteProp } from "@react-navigation/native";

type StackNavigationParam = {
  ReviewByOfferToUser: {
    id: string;
  };
};

export const ReviewByOfferToUserScreen: React.FC = () => {
  const route =
    useRoute<RouteProp<StackNavigationParam, "ReviewByOfferToUser">>();
  const [items, loading] = useReviewsByOfferToUser(route.params.id);
  return (
    <View
      style={[
        styles.container,
        items.length === 0 && !loading ? styles.notFound : {},
      ]}
    >
      {items.length > 0 ? (
        <ScrollView>
          {items.map((item) => (
            <ReviewCard
              key={item.id}
              review={item}
              containerStyle={styles.card}
              onPress={() => console.log("onReview...")}
            />
          ))}
        </ScrollView>
      ) : null}
      {items.length === 0 && !loading ? <NotFound /> : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.white,
  },
  notFound: {
    backgroundColor: colors.gray1,
  },
  card: {
    marginVertical: 8,
    marginHorizontal: 8,
  },
});
